/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import ChocolateBox from '../valentinespuzzle/ChocolateBox';
import DraggableSprite from '../valentinespuzzle/DraggableSprite';
import Emitter from '../valentinespuzzle/Emitter';
import SpriteLabel from '../valentinespuzzle/SpriteLabel';
import IntroScreen from './IntroScreen';

export default class GameScreen extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  init() {
    /** @type {Phaser.GameObjects.Image[]} */
    this.chocolates = [];

    /** @type {DraggableSprite[]} */
    this.chocolatesReplaced = [];

    /** @type {Phaser.GameObjects.Image[]} */
    this.holes = [];
    this.chocolatesPlaced = 0;
    this.chocolatesEaten = 0;
    this.startEatingChocolates = false;

    // drag fix
    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  create() {
    const backgroundImage = ABCyaPhaser.Images.addImage(-17,-11,UIAssetKeys._background, this).setOrigin(0);

    this.box = new ChocolateBox(this);
    this.add.existing(this.box);
    this.box.x = this.scale.width / 2;
    this.box.y = this.scale.height / 2;
    this.box.scale = 0.85;

    const cover = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2, UIAssetKeys._candy_box_cover, this);
    cover.scale = 0.85;

    ABCyaPhaser.Tweens.addTween(cover, 2000, { x: cover.x + 1200, angle: 360 * 2 }, Phaser.Math.Easing.Linear);

    for (let i = 0; i < 13; i++) {
      const box = ABCyaPhaser.Images.addImage(0,0,`chocolate_hole${i + 1}`,this);
      this.holes.push(box);
      const yAdj = 96;

      let localPt = new Phaser.Math.Vector2();
      switch (i) {
        case 0:
          localPt = this.box.getLocalPoint(512 , 104 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 1:
          localPt = this.box.getLocalPoint(413, 141 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 2:
          localPt = this.box.getLocalPoint(516, 194 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 3:
          localPt = this.box.getLocalPoint(631, 165 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 4:
          localPt = this.box.getLocalPoint(359, 217 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 5:
          localPt = this.box.getLocalPoint(516, 288 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 6:
          localPt = this.box.getLocalPoint(676, 269 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 7:
          localPt = this.box.getLocalPoint(409, 307 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 8:
          localPt = this.box.getLocalPoint(581, 355 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 9:
          localPt = this.box.getLocalPoint(369, 385 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 10:
          localPt = this.box.getLocalPoint(468, 396 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 11:
          localPt = this.box.getLocalPoint(528 + 6, 447 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 12:
          localPt = this.box.getLocalPoint(652, 396 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;
      }

      this.box.add(box);
    }

    const yAdj = 96;
    for (let i = 0; i < 13; i++) {
      const box = ABCyaPhaser.Images.addImage(0,0,`chocolate${i + 1}`,this);
      this.chocolates.push(box);

      let localPt = new Phaser.Math.Vector2();
      switch (i) {
        case 0:
          localPt = this.box.getLocalPoint(512, 104 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 1:
          localPt = this.box.getLocalPoint(413, 141 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 2:
          localPt = this.box.getLocalPoint(516, 194 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 3:
          localPt = this.box.getLocalPoint(631, 165 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 4:
          localPt = this.box.getLocalPoint(359, 217 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 5:
          localPt = this.box.getLocalPoint(516, 288 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 6:
          localPt = this.box.getLocalPoint(676, 269 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 7:
          localPt = this.box.getLocalPoint(409, 307 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 8:
          localPt = this.box.getLocalPoint(581, 355 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 9:
          localPt = this.box.getLocalPoint(369, 385 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 10:
          localPt = this.box.getLocalPoint(468, 396 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 11:
          localPt = this.box.getLocalPoint(528 + 6, 447 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;

        case 12:
          localPt = this.box.getLocalPoint(652, 396 + 10 + yAdj);
          box.x = localPt.x;
          box.y = localPt.y;
          break;
      }

      this.box.add(box);
    }

    this.time.delayedCall(1000, this.spinCandy,null, this);
  }

  spinCandy () {
    ABCyaPhaser.Tweens.addTween(this.box, 2000, { angle: 360 * 2 }, Phaser.Math.Easing.Linear);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_scramble, this);

    for (let i = 0; i < 13; i++) {
      const box = this.chocolates[i];

      this.time.delayedCall(i * 100, this.replaceChocolateOnSpin, [box, i], this);
    }

    this.chocolates = [];

    this.time.delayedCall(2000, this.showIntroDialog, null, this);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} chocolate 
   * @param {*} i 
   */
  replaceChocolateOnSpin (chocolate, i) {
    const target = this.holes[i];

    const matrix = chocolate.getWorldTransformMatrix();
    this.box.remove(chocolate, true);

    const box = new DraggableSprite(this, `chocolate${i + 1}`).disableInteractive();
    box.enabled = true;
    this.chocolatesReplaced.push(box);

    box.scale = 0.85;

    box.x = matrix.tx;
    box.y = matrix.ty;
    box.rotation = matrix.rotation;

    box.hitTargets.push(target);
    box.hitListener = this.targetHit.bind(this);
    box.outListener = this.targetOut.bind(this);

    this.add.existing(box);

    const yAdj = 96;

    let finalX = 0;
    let finalY = 0;

    switch (i) {
      case 0:
        finalX = 840 - 50;
        finalY = 120 - 50 + yAdj;
        break;

      case 1:
        finalX = 900 - 50;
        finalY = 220 - 50 + yAdj;
        break;

      case 2:
        finalX = 950 - 50;
        finalY = 350 - 50 + yAdj;
        break;

      case 3:
        finalX = 950 - 50;
        finalY = 470 - 50 + yAdj;
        break;

      case 4:
        finalX = 850 - 50;
        finalY = 570 - 70 + yAdj;
        break;

      case 5:
        finalX = 1000 - 50;
        finalY = 590 - 70 + yAdj;
        break;

      case 6:
        finalX = 190 - 60;
        finalY = 580 - 70 + yAdj;
        break;

      case 7:
        finalX = 310 - 50;
        finalY = 570 - 50 + yAdj;
        break;

      case 8:
        finalX = 270 - 50;
        finalY = 470 - 50 + yAdj;
        break;

      case 9:
        finalX = 220 - 50;
        finalY = 360 - 50 + yAdj;
        break;

      case 10:
        finalX = 240 - 50;
        finalY = 245 - 50 + yAdj;
        break;

      case 11:
        finalX = 180 - 50;
        finalY = 130 - 50 + yAdj;
        break;

      case 12:
        finalX = 295 - 50;
        finalY = 130 - 50 + yAdj;
        break;
    }

    ABCyaPhaser.Tweens.addTween(box, 500, { x: finalX, y: finalY, angle: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(box, 250, { scale: 1.4 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(box, 250, { scale: 0.85 }, Phaser.Math.Easing.Linear);
    });

    box.lastPosX = finalX;
    box.lastPosY = finalY;
  }

  targetHit (chocolate) {
    chocolate.enabled = false;

    const choice = Phaser.Math.Between(1, 4);
    let correctSound = null;

    if (choice === 1) {
      correctSound = SoundAssetKeys._chocolatey;
    }
    else if (choice === 2) {
      correctSound = SoundAssetKeys._gooey;
    }
    else if (choice === 3) {
      correctSound = SoundAssetKeys._sweetness;
    }
    else {
      correctSound = SoundAssetKeys._mmmm;
    }

    ABCyaPhaser.Audio.playOneShot(correctSound, this);
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_pop, this);

    this.chocolatesPlaced++;

    if (this.chocolatesPlaced === 13) {
      this.time.delayedCall(1200, this.showWinDialog, null, this);
    }

    const matrix = chocolate.hitTargets[0].getWorldTransformMatrix();
    chocolate.x = matrix.tx;
    chocolate.y = matrix.ty;
  }

  showWinDialog () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_win, this);

    this.time.delayedCall(1000, this.tapToEat,null,this);

    this.wonDialog = new SpriteLabel(this, 1,UIAssetKeys._rounded_rect);

    this.wonDialog.x = this.scale.width / 2;
    this.wonDialog.y = this.scale.height / 2 - 700;
    this.wonDialog.doAction = () => this.chocolatesReplaced.forEach(sprite => sprite.setInteractive());
    this.add.existing(this.wonDialog);

    ABCyaPhaser.Tweens.addTween(this.wonDialog, 1400, { y: this.wonDialog.y + 700 }, Phaser.Math.Easing.Bounce.Out);

    for (let i = 0; i < this.chocolatesReplaced.length; i++) {
      const choc = this.chocolatesReplaced[i];
      choc.doClickAction = this.eatChocolate.bind(this);
      choc.enabled = false;
      choc.disableInteractive();
    }
  }

  tapToEat () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tap_to_eat, this);
  }

  eatChocolate (chocolate) {
    this.chocolatesEaten++;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._chomp_05, this);

    this.makeChocolateExplosion(chocolate);

    if (this.chocolatesEaten === 12) {
      this.time.delayedCall(1200, this.showEatenDialog,null,this);
    }
  }

  makeChocolateExplosion (chocolate) {
    const emitter = new Emitter(this);
    emitter.x = chocolate.x - 50;
    emitter.y = chocolate.y;

    this.add.existing(emitter);
    emitter.emitChocolate();

    chocolate.destroy();
  }

  showEatenDialog () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._burp, this);

    this.time.delayedCall(400, this.youAteAll, null,this);

    this.eatenDialog = new SpriteLabel(this, 2, UIAssetKeys._rounded_rect);

    this.eatenDialog.x = this.scale.width / 2;
    this.eatenDialog.y = this.scale.height / 2 - 700;
    this.add.existing(this.eatenDialog);
    this.eatenDialog.doAction = this.cleanUp.bind(this);

    ABCyaPhaser.Tweens.addTween(this.eatenDialog, 1400, { y: this.eatenDialog.y + 700 }, Phaser.Math.Easing.Bounce.Out);
  }

  youAteAll () {
    this.youAteAllSound = ABCyaPhaser.Audio.createSound(this);
    this.youAteAllSound.once(Phaser.Sound.Events.COMPLETE, () => {
      this.youAteAllSound.destroy();
      this.youAteAllSound = null;
    }).once(Phaser.Sound.Events.STOP, () => {
      this.youAteAllSound.destroy();
      this.youAteAllSound = null;
    });
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._you_ate_all, this.youAteAllSound);
  }

  cleanUp () {
    if (this.youAteAllSound) {
      this.youAteAllSound.destroy();
      this.youAteAllSound = null;
    }

    this.scene.start(IntroScreen.KEY);
  }

  /**
   * 
   * @param {DraggableSprite} heart 
   */
  targetOut (heart) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._swish, this);
    heart.moveToLastPosition();
  }

  showIntroDialog () {
    this.chocolateFellOutSound = ABCyaPhaser.Audio.createSound(this);
    this.chocolateFellOutSound.once(Phaser.Sound.Events.COMPLETE, () => {
      this.chocolateFellOutSound.destroy();
      this.chocolateFellOutSound = null;
    }).once(Phaser.Sound.Events.STOP, () => {
      this.chocolateFellOutSound.destroy();
      this.chocolateFellOutSound = null;
    });
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._chocolates_fell_out, this.chocolateFellOutSound);

    this.introDialog = new SpriteLabel(this, 3,UIAssetKeys._rounded_rect);

    this.introDialog.x = this.scale.width / 2;
    this.introDialog.y = this.scale.height / 2 - 700;
    this.add.existing(this.introDialog);
    this.introDialog.doAction = this.introDone.bind(this);

    ABCyaPhaser.Tweens.addTween(this.introDialog, 1400, { y: this.introDialog.y + 700 }, Phaser.Math.Easing.Bounce.Out);
  }

  introDone () {
    if (this.chocolateFellOutSound) {
      this.chocolateFellOutSound.destroy();
      this.chocolateFellOutSound = null;
    }

    this.chocolatesReplaced.forEach(sprite => sprite.setInteractive());
  }
}